import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'src/app/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  endpoint:any;
  constructor(private http: HttpClient, private configService: ConfigService) { 
    this.endpoint = this.configService.endpoints;
  }

  getPatientinfo(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Patient/${id}`);
  }

  getLabClient(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/LabClient/${id}`);
  }

  getCaseOrderDrug(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/CaseOrderDrug/list/prescribedmedications/${id}`);
  }

  getPreviousCaseICDCodes(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/CaseOrder/GetPreviousCaseICDCodes/${id}/0`);
  }

  getInsuranceDetails(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/InsuranceDetails/patientByPatientId/${id}`);
  }

  getCaseInfoById(id, isCaseOrderInfo) {
    if (isCaseOrderInfo) {
      return this.http.get<any>(`${this.endpoint.APIEndpoint}/CaseOrder/info/${id}`);
    } else {
      return this.http.get<any>(`${this.endpoint.APIEndpoint}/CaseInfo/case/${id}`);
    }
  }

  getToxPatientHistory(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/ToxPatientHistory/list/${id}`);
  }


  // view log api start

  getChemicalCompoundLogs(compoundId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/ChemicalCompound/logs/list/${compoundId}?PageSize=300&RunCount=true&StartPageNo=1&sortExpression=`);
  }

  getCompoundLogs(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Compound/logs/${id}`);
  }

  getCompoundTestValidityLogs(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/testcode/logs/by/id/${id}`);
  }
  getTestCodeLogs(id, filterModel, customFilter){
    return `${this.endpoint.APIEndpoint}/testcode/logs/${id}?${filterModel.PageSize}&${filterModel.RunCount}&${filterModel.StartPageNo}&${filterModel.SortExpression}&${customFilter}`;
  }
  getProfileLogsList(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/profile/logs/${id}`);
  }
  getProfileLogs(profileId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/profile/logs/${profileId}`);
  }

  userAcitivityLog(userId, filterModel, customFilter) {
    return `${this.endpoint.APIEndpoint}/user/activitylog/${userId}?${filterModel.PageSize}&${filterModel.RunCount}&${filterModel.StartPageNo}&${filterModel.SortExpression}&${customFilter}`;
  }

  userProfileAcitivityLog(userId, filterModel, customFilter) {
    return `${this.endpoint.APIEndpoint}/UserRole/logs/${userId}?${filterModel.PageSize}&${filterModel.RunCount}&${filterModel.StartPageNo}&${filterModel.SortExpression}&${customFilter}`;
  }

  getReagentInfoLogs(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/ReagentInfo/logs/${id}`);
  }

  getEquipmentLogs(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Equipment/logs/${id}`);
  }

  getRoleAcitivityLog(roleId, filterModel, customFilter) {
    return `${this.endpoint.APIEndpoint}/Role/logs/list/${roleId}?${filterModel.PageSize}&${filterModel.RunCount}&${filterModel.StartPageNo}&${filterModel.SortExpression}&${customFilter}`;
  }

  // view log api end

  getCaseNotes(caseOrderId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/CaseOrderNote/list/${caseOrderId}`);
  }

  getPatientInsuranceByCaseId(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/InsuranceDetails/patientByCaseId/${id}`);
  }
  getInsuranceDetailsByCaseInfo(caseInfoId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/InsuranceDetails/CaseInfoId/${caseInfoId}`);
  }

}
